import { Users, TrendingUp, GraduationCap } from "lucide-react";
import PhotoCarousel from "@/components/site/PhotoCarousel";

const PHOTOS = [
  {
    src: "https://customer-assets-cm19k8pv.emergentagent.net/job_baseball-coach-site/artifacts/sseczhmn_Screenshot_27-9-2026_174329_www.instagram.com.jpeg",
    alt: "Brady Hamilton in Atlanta Braves uniform",
    eyebrow: "Coach Brady Hamilton",
    caption: "Atlanta Braves Pitcher.\nPlayer's Coach.",
    fit: "contain",
  },
  {
    src: "https://images.sidearmdev.com/fit?url=https%3a%2f%2fdxbhsrqyrr690.cloudfront.net%2fsidearm.nextgen.sites%2fwichita.sidearmsports.com%2fimages%2f2025%2f9%2f3%2fBrady_Hamilton_Clean.png&height=800&width=600&type=jpeg",
    alt: "Brady Hamilton pitching for Wichita State",
    eyebrow: "Wichita State University",
    caption: "Where the journey started.",
  },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 px-6 md:px-10 bg-[#0a0a0a] border-t border-[#1a1a1a]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        {/* Image column */}
        <div className="lg:col-span-5 relative">
          <PhotoCarousel photos={PHOTOS} />

          <div className="hidden lg:flex items-center gap-3 mt-6 px-4 py-3 border border-[#2a2a2a] bg-[#141414]">
            <span className="w-2 h-2 rounded-full bg-[#eab308] bham-dot" />
            <span className="font-condensed uppercase tracking-[0.2em] text-xs text-neutral-300">
              Currently coaching remotely & in-person
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-8 h-px bg-[#eab308]" />
            <span className="font-condensed uppercase tracking-[0.25em] text-xs text-[#eab308]">
              About Me
            </span>
          </div>

          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mb-8">
            From <span className="text-[#eab308]">65</span> To
            <br />
            <span className="text-[#eab308]">95+</span> — And Now I
            <br />
            Help You Get There.
          </h2>

          <div className="space-y-5 text-neutral-300 text-base md:text-lg leading-relaxed max-w-2xl">
            <p>
              I'm a{" "}
              <span className="text-white font-semibold">
                Professional Pitcher in the Atlanta Braves organization
              </span>{" "}
              who developed from a{" "}
              <span className="text-[#eab308] font-semibold">65 mph</span> high
              school freshman into a{" "}
              <span className="text-[#eab308] font-semibold">95+ mph</span>{" "}
              starter at the highest level of college baseball at{" "}
              <span className="text-white font-semibold">Wichita State University</span>.
            </p>
            <p>
              Along the way, I've trained with{" "}
              <span className="text-white font-semibold">MLB coaches</span> and
              professional pitching minds, building a deep understanding of
              mechanics, velocity development, strength, and mindset.
            </p>
            <p className="text-white">
              My goal is simple: help athletes unlock their full potential with
              real, experience-based coaching that actually translates to
              performance on the mound.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-10">
            <Card
              icon={Users}
              title="10+ MLB Coaches"
              sub="Trained alongside pro pitching minds"
            />
            <Card
              icon={TrendingUp}
              title="+6 MPH Avg"
              sub="Avg velocity gained by my athletes in 2025"
            />
            <Card
              icon={GraduationCap}
              title="25+ Athletes"
              sub="Careers extended & elevated"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function Card({ icon: Icon, title, sub }) {
  return (
    <div className="border border-[#2a2a2a] bg-[#141414] p-5 hover:border-[#eab308] transition-all">
      <Icon className="text-[#eab308] mb-3" size={20} />
      <div className="font-display text-xl">{title}</div>
      <div className="font-condensed uppercase tracking-[0.2em] text-[11px] text-neutral-500 mt-1">
        {sub}
      </div>
    </div>
  );
}
